import React, { useState } from 'react'
import { Trans, t } from '@lingui/macro'

import validations from '../../../../shared/validations'
import { ButtonPrimary } from 'front-end/src/components'
import { notification } from '../../components/common/notifications/Notifications'
import { AccessibilityLabel } from '../../components/common/AccessibilityLabel'
import { useUserUpdatePasswordMutation } from './UserUpdatePassword.codegen'

const UserUpdatePassword = ({ user }) => {
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')

  const [changeUserPassword, { loading }] = useUserUpdatePasswordMutation()

  return (
    <form className="form">
      <div className="form-row">
        {user.password_last_updated_at ? (
          <>
            <h4>
              <Trans>Update your password</Trans>
            </h4>
            <br />
            <p>
              <Trans>
                Enter your old and new password in the fields below. Passwords
                must be at least 8 characters containing both letters and
                numbers.
              </Trans>
            </p>
          </>
        ) : (
          <>
            <h4>
              <Trans>Set your password</Trans>
            </h4>
            <br />
            <p>
              <Trans>
                Set your password in the field below. The new password must be
                at least 8 characters containing both letters and numbers.
              </Trans>
            </p>
          </>
        )}
      </div>
      {user.password_last_updated_at && (
        <div className="form-row">
          <AccessibilityLabel text={t`Old password`}>
            <input
              autoComplete="current-password"
              type="password"
              className="form-textInput"
              placeholder={t`Old password`}
              onChange={(e) => setOldPassword(e.currentTarget.value)}
            />
          </AccessibilityLabel>
        </div>
      )}
      <div className="form-row">
        <AccessibilityLabel text={t`New password`}>
          <input
            type="password"
            className="form-textInput"
            autoComplete="new-password"
            placeholder={t`New password`}
            required
            onChange={(e) => setNewPassword(e.currentTarget.value)}
          />
        </AccessibilityLabel>
      </div>

      <div className="form-row">
        <ButtonPrimary
          onClick={async () => {
            const result = await changeUserPassword({
              variables: {
                oldPassword: oldPassword,
                newPassword: newPassword
              }
            })
            if (result.data && result.data.me.setPassword?.id) {
              notification.info(t`Password successfully updated`)
            }
          }}
          isLoading={loading}
          disabled={
            !(newPassword && newPassword.match(validations.passwordRegex)) ||
            loading
          }
        >
          <Trans>Update password</Trans>
        </ButtonPrimary>
      </div>
    </form>
  )
}
export default UserUpdatePassword
